import axios from '../_utils/axios';

// ----------------------------------------------------------------------

const refreshPotentialDashboards = async (groupId) => {
  return await axios.get(`potential-dashboards/groups/${groupId}/refresh`)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default refreshPotentialDashboards;